import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './SalonLayout.css';

// Initials from the first two words of the salon name (e.g. "Ulloor Styles Web" -> "US").
// Single-word names fall back to the word's first two letters.
function getSalonInitials(name) {
  const words = (name || '').trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return 'SD';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

function SalonLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, salonData } = useAuth();

  const handleLogout = async () => {
    // Show confirmation dialog
    const confirmed = window.confirm('Are you sure you want to logout?');
    
    if (!confirmed) {
      return; // User cancelled, do nothing
    }

    try {
      await logout();
      navigate('/login');
    } catch (error) {
      alert('Failed to logout. Please try again.');
    }
  };

  const menuItems = [
    { path: '/salon/dashboard', label: 'Dashboard', icon: '📊' },
    { path: '/salon/bookings', label: 'Bookings', icon: '📅' },
    { path: '/salon/profile', label: 'Profile', icon: '🏪' },
    { path: '/salon/services', label: 'Services & Pricing', icon: '💇' },
    { path: '/salon/staff-management', label: 'Staff Management', icon: '🧑‍🤝‍🧑' },
    { path: '/salon/payments', label: 'Payments', icon: '💰' },
    { path: '/salon/advance-payments', label: 'Advance Payments', icon: '💳' }
  ];

  return (
    <div className="salon-layout">
      {/* Sidebar */}
      <aside className="salon-sidebar">
        <div className="salon-sidebar-header">
          <div
            className="salon-avatar"
            title={salonData?.profile?.shopName || 'Salon Dashboard'}
          >
            {getSalonInitials(salonData?.profile?.shopName)}
          </div>
        </div>

        <nav className="salon-nav">
          {menuItems.map((item) => (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`salon-nav-item ${location.pathname === item.path ? 'active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </button>
          ))}
        </nav>

        <div className="salon-sidebar-footer">
          <button onClick={handleLogout} className="logout-btn">
            <span className="nav-icon">🚪</span>
            <span className="nav-label">Logout</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <div className="salon-main">
        {/* Header */}
        <header className="salon-header">
          <div className="salon-header-content">
            <h1>Welcome, {salonData?.profile?.ownerName || 'Salon Owner'}</h1>
            <div className="salon-header-info">
              <span className="salon-phone">📞 {salonData?.phoneNumber}</span>
              <span className={`salon-status ${salonData?.approvalStatus === 'approved' ? 'approved' : ''}`}>
                {salonData?.approvalStatus === 'approved' ? '✓ Approved' : 'Pending'}
              </span>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="salon-content">
          {children}
        </main>
      </div>
    </div>
  );
}

export default SalonLayout;



